import { useRef, useState } from "react";
import {
  Button,
  PageHeader,
} from "lift-ui";
import { Plus, RefreshCw } from "lucide-react";
import { useAuthContext } from "@lift-admin/utils/provider";
import AffluentImports from "../components/affluent-imports";

const ImportSection = ({ state }: any) => {
  const { canEdit, canManage } = useAuthContext();
  const hasEditAccess = canEdit("affiliate_mgmt");
  const canTriggerAffluentImport = canManage("affiliate_mgmt");

  const childRef = useRef<any>(null);
  const [searchText, setSearchText] = useState("");
  const [affluentCount, setAffluentCount] = useState(0);
  const [affluentTotal, setAffluentTotal] = useState(0);

  const handleAddClick = () => {
    childRef.current?.addAffluentTrigger();
  };

  const handleRefreshLogs = () => {
    childRef.current?.getAffluentData();
  };

  return (
    <div className="flex flex-col h-full bg-white">
      <PageHeader
        title={`Affluent Import ${!searchText.trim() ? `(${affluentCount})` : `(${affluentCount} of ${affluentTotal})`}`}
        renderCustomTop={
          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              size="sm"
              onClick={handleRefreshLogs}
              className="flex items-center gap-2 h-8 px-3"
            >
              <RefreshCw className="h-4 w-4" />
              Refresh
            </Button>
            {canTriggerAffluentImport && (
              <Button onClick={handleAddClick} size="sm" className="flex items-center gap-2 h-8 px-3">
                <Plus className="h-4 w-4" />
                Trigger Import Affluent
              </Button>
            )}
          </div>
        }
      />

      <div className="flex-1 flex flex-col min-h-0 px-8 pt-8 pb-4">
        <div className="flex-1 min-h-0">
          <AffluentImports
            childRef={childRef}
            searchText={searchText}
            state={state}
            hasEditAccess={hasEditAccess}
            canTriggerImport={canTriggerAffluentImport}
            onCountChange={(filtered: number, total?: number) => {
              setAffluentCount(filtered);
              setAffluentTotal(total ?? filtered);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ImportSection;
